import React from 'react';
import { Link } from 'react-router-dom';
import { Card, Button } from '../../components';

const NotFound = () => {
  return (
    <div className="section-gap">
      <Card>
        <div className="text-center py-16">
          <div className="w-24 h-24 bg-danger/20 rounded-full flex items-center justify-center mx-auto mb-8">
            <svg className="w-12 h-12 text-danger" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
            </svg>
          </div>
          
          <h1 className="text-6xl font-bold text-text mb-4">404</h1>
          <h2 className="text-2xl font-semibold text-text mb-4">Page Not Found</h2>
          <p className="text-muted text-lg mb-8 max-w-md mx-auto">
            Sorry, we couldn't find the page you're looking for. It might have been moved, deleted, or you entered the wrong URL.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/app/dashboard/founder">
              <Button variant="primary" size="lg" className="px-8">
                Go to Dashboard
              </Button>
            </Link>
            <Button 
              variant="ghost" 
              size="lg" 
              className="px-8"
              onClick={() => window.history.back()}
            >
              Go Back
            </Button>
          </div>
          
          <div className="mt-12 pt-8 border-t border-line">
            <p className="text-muted text-sm mb-4">Need help? Try these popular pages:</p>
            <div className="flex flex-wrap gap-4 justify-center">
              <Link to="/app/lms/courses" className="text-chart hover:text-text transition-colors text-sm">
                Courses
              </Link>
              <Link to="/app/mentors" className="text-chart hover:text-text transition-colors text-sm">
                Mentors
              </Link>
              <Link to="/app/program/timeline" className="text-chart hover:text-text transition-colors text-sm">
                Program Timeline
              </Link>
              <Link to="/app/startup" className="text-chart hover:text-text transition-colors text-sm">
                My Startup
              </Link>
              <Link to="/app/resources" className="text-chart hover:text-text transition-colors text-sm">
                Resources
              </Link>
            </div>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default NotFound;